import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from "react-router-dom";
import './App.css';
import Login from './components/login';
import Home from './components/home';
import Gestiones from './components/factlectronica/gestiones';
import Reportes from './components/reportes';
import Usuarios from './components/usuarios';
import Resoluciones from './components/resoluciones';
import {ProtectedRoute} from './middleware/protected.route';
import FormularioUsuario from './components/formularioUsuario';
import FormularioResolucion from './components/formularioResolucion';
import FormularioEmpresa from './components/formularioEmpresa';
import Empresas from './components/empresas';
import Parametros from './components/nomina/formularioParametros';
import PagoNomina from './components/nomina/formularioPagoNomina';
import Email from './components/configMail';
import Impresion from './components/factlectronica/impresion';
import Confirmacion from './components/confirmacion';
import CerrarSesion from './components/cerrarsesion';
import LoginClientes from './components/login_clientes';

//RUTAS Facturar365
import Formapago from './components/bussines/formaspago';
import Formularioformapago from './components/bussines/formularioFormaPago';

import Categoriaitem from './components/bussines/categoriaitem';
import Formulariocategoriaitem from './components/bussines/formularioCategoriaitems';

import Impuestos from './components/bussines/impuestos';
import Formularioimpuestos from './components/bussines/formularioImpuestos';

import Retenciones from './components/bussines/retenciones';
import Formularioretenciones from './components/bussines/formularioRetenciones';

import Servicios from './components/bussines/itemServicios';
import Formularioservicios from './components/bussines/formularioItemsServicios';

import Clientes from './components/bussines/clientes';
import Formularioclientes from './components/bussines/formularioClientes';

import Listaprecio from './components/bussines/listaPrecios';
import Precios from './components/bussines/precios';

import Vendedores from './components/bussines/vendedores';
import Formulariovendedores from './components/bussines/formularioVendedores';

import Facturas from './components/bussines/ventas/facturas';
import Notacredito from './components/bussines/ventas/notasCredito';
import Notadebito from './components/bussines/ventas/notasDebito';

import Cargaterceros from './components/archivos/cargaTerceros'

import Pedidos from './components/bussines/pedidos/pedidos'
import PedidosCust from './components/bussines/pedidos/pedidosCust'
import pedidosMovil from './components/bussines/pedidos/pedidosMovil';
import generadorPlano from './components/bussines/pedidos/generadorPlano';
import ConvetidorFacturas from './components/bussines/pedidos/convertidorFacturas';

import turnos from './components/turnos';
import post from './components/bussines/ventas/post';
import cierreTurno from './components/reportes/cierreTurno';
import Unidadmedida from './components/bussines/unidadmedida';
import Metodospago from './components/bussines/metodospago';
import FormularioMetodoPago from './components/bussines/formularioMetodoPago';
import ImpresionPos from './components/bussines/ventas/impresionPos';
import ReporteVentas from './components/bussines/ventas/reporteVentas';
import ReporteDocumentos from './components/bussines/ventas/reporteDocumentos';
import ReporteAcuse from './components/factlectronica/reporteAcuse';
import IngresoInventario from './components/bussines/inventarios/ingresoInventario';
import Bodegas from './components/bussines/inventarios/bodegas';
import AjusteInventario from './components/bussines/inventarios/ajusteInventario';
import TransladoInventario from './components/bussines/inventarios/transladoInventario';
import ReporteExitencia from './components/bussines/inventarios/reporteExitencia';
import ReporteMovimiento from './components/bussines/inventarios/reporteMovimiento';
import TiposInventario from './components/categorizacion/tipoInventario';
import GrupoInventario from './components/categorizacion/grupoInventario';
import LineasInventario from './components/categorizacion/lineasInventario';
import Reportepedidos from './components/bussines/pedidos/reportepedidos';
import ReportepedidosCust from './components/bussines/pedidos/reportepedidosCust';
import EditPedidos from './components/bussines/pedidos/Editpedidos';
//import ReporteEmpresas from './components/reporteEmpresas';
import FormularioCustomer from './components/formularioCustomer';
//import Notacredito from './components/bussines/ventas/notasCredito'7
import ReporteEmpresas from './components/factlectronica/reporteEmpresas';
import RecibosCaja from './components/bussines/cartera/recibosCaja';
import ReporteCartera from './components/bussines/cartera/reporteCartera';
import ReporteRecibos from './components/bussines/cartera/reporteRecibos';
import ReporteDetallado from './components/factlectronica/ReporteDetallado';
import ClientesCarga from './components/bussines/cargacatalogos/clientes';
import ItemsCarga from './components/bussines/cargacatalogos/items';
import PreciosCarga from './components/bussines/cargacatalogos/precios';
import CodigoBarra from './components/bussines/codigoBarraitem';
import Formulariocodigobarras from './components/bussines/formularioCodigoBarra';
import Empleados from './components/nomina/empleados';
import Formularioempleados from './components/nomina/formularioEmpleado';
import GestionNomina from './components/nomina/gestionesNomina';
import EmpresasAdmin from './components/empresaadmin';
import ReporteSalto from './components/reportes/reporteSalto';
import ReporteNomina from './components/factlectronica/reporteNomina';
import ReporteDetalladoNomina from './components/nomina/ReporteDetallado';
import AprobadorPedidos from './components/bussines/pedidos/aprobadorPedidos';
import HomologacionNomina from './components/nomina/homologacion';
import Descuentos from './components/bussines/descuentos';
import GestionesEmpleados from './components/nomina/gestionesNominaEmpleados';
import ReporteConsumo from './components/reportes/reporteConsumo';
import ReporteConsolidadoEmp from './components/nomina/ReportConsolidadoEmp';
import DocumentoSoporte from './components/bussines/ventas/documentoSoporte';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="App-header">
          <BrowserRouter>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/login_clientes" component={LoginClientes}/> 
              <Route exact path="/confirmacion" component={Confirmacion} /> 
              <ProtectedRoute exact path="/formularioCustomer" component={FormularioCustomer} />
              <ProtectedRoute exact path="/home" component={Home} />
              <ProtectedRoute exact path="/gestion" component={Gestiones} />
              <ProtectedRoute exact path="/reportes" component={Reportes} />
              <ProtectedRoute exact path="/usuarios" component={Usuarios} />
              <ProtectedRoute exact path="/usuarios/crear" component={FormularioUsuario} />  
              <ProtectedRoute exact path="/resoluciones" component={Resoluciones} />
              <ProtectedRoute exact path="/resoluciones/crear" component={FormularioResolucion} />
              <ProtectedRoute exact path="/empresa" component={Empresas} />
              <ProtectedRoute exact path="/empresa/crear" component={FormularioEmpresa} />
              <ProtectedRoute exact path="/parametros" component={Parametros} />
              <ProtectedRoute exact path="/pagonomina" component={PagoNomina} />
              <ProtectedRoute exact path="/cerrarsesion" component={CerrarSesion} />  
              <ProtectedRoute exact path="/email" component={Email} />
              <ProtectedRoute exact path="/reportes" component={Reportes} />      
              <ProtectedRoute exact path="/prefacturas" component={Impresion} />
              <ProtectedRoute exact path="/formapago" component={Formapago} />
              <ProtectedRoute exact path="/formapago/crear" component={Formularioformapago} />
              <ProtectedRoute exact path="/categorias" component={Categoriaitem} />
              <ProtectedRoute exact path="/categorias/crear" component={Formulariocategoriaitem} />     
              <ProtectedRoute exact path="/impuestos" component={Impuestos} />
              <ProtectedRoute exact path="/impuestos/crear" component={Formularioimpuestos} />
              <ProtectedRoute exact path="/retenciones" component={Retenciones} />
              <ProtectedRoute exact path="/retenciones/crear" component={Formularioretenciones} />         
              <ProtectedRoute exact path="/listaprecio" component={Listaprecio} />     
              <ProtectedRoute exact path="/listaprecio/actualizar" component={Precios} />                  
              <ProtectedRoute exact path="/servicios" component={Servicios} />
              <ProtectedRoute exact path="/servicios/crear" component={Formularioservicios} />
              <ProtectedRoute exact path="/clientes" component={Clientes} />
              <ProtectedRoute exact path="/clientes/crear" component={Formularioclientes} />  
              <ProtectedRoute exact path="/vendedores" component={Vendedores} />
              <ProtectedRoute exact path="/vendedores/crear" component={Formulariovendedores} />         
              <ProtectedRoute exact path="/facturas" component={Facturas} />      
              <ProtectedRoute exact path="/notasc" component={Notacredito} />      
              <ProtectedRoute exact path="/notasd" component={Notadebito} />      
              <ProtectedRoute exact path="/cargaterceros" component={Cargaterceros} />      
              <ProtectedRoute exact path="/pedidos" component={Pedidos} />
              <ProtectedRoute exact path="/pedidosCust" component={PedidosCust} />       
              <ProtectedRoute exact path="/pedidosmovil" component={pedidosMovil} />      
              <ProtectedRoute exact path="/generarplanopedidos" component={generadorPlano} />      
              <ProtectedRoute exact path="/aprobarpedidos" component={AprobadorPedidos} />      
              <ProtectedRoute exact path="/turnos" component={turnos} />      
              <ProtectedRoute exact path="/factpost" component={post} /> 
              <ProtectedRoute exact path="/reportes/cierreturno" component={cierreTurno} /> 
              <ProtectedRoute exact path="/unidades" component={Unidadmedida} /> 
              <ProtectedRoute exact path="/metodos" component={Metodospago} /> 
              <ProtectedRoute exact path="/metodos/crear" component={FormularioMetodoPago} />
              <ProtectedRoute exact path="/impresionpos" component={ImpresionPos} />
              <ProtectedRoute exact path="/reporte/ventas" component={ReporteVentas} />
              <ProtectedRoute exact path="/reporte/documentos" component={ReporteDocumentos} />
              <ProtectedRoute exact path="/acuse" component={ReporteAcuse} />
              <ProtectedRoute exact path="/ingresoinventario" component={IngresoInventario} />
              <ProtectedRoute exact path="/bodegas" component={Bodegas} />
              <ProtectedRoute exact path="/ajusteinventario" component={AjusteInventario} />
              <ProtectedRoute exact path="/transladoinventario" component={TransladoInventario} />
              <ProtectedRoute exact path="/reporte/existencia" component={ReporteExitencia} />
              <ProtectedRoute exact path="/reporte/movimiento" component={ReporteMovimiento} />
              <ProtectedRoute exact path="/tipoinventario" component={TiposInventario} />
              <ProtectedRoute exact path="/grupoinventario" component={GrupoInventario} />
              <ProtectedRoute exact path="/lineasinventario" component={LineasInventario} />
              <ProtectedRoute exact path="/convertidorpedfac" component={ConvetidorFacturas} />
              <ProtectedRoute exact path="/reportepedidos" component={Reportepedidos} />
              <ProtectedRoute exact path="/reportepedidosCust" component={ReportepedidosCust} />
              <ProtectedRoute exact path="/editpedidos" component={EditPedidos} />
             
              <ProtectedRoute exact path="/cargaclientes" component={ClientesCarga} />
              <ProtectedRoute exact path="/cargaitems" component={ItemsCarga} />
              <ProtectedRoute exact path="/cargaprecios" component={PreciosCarga} />
              <ProtectedRoute exact path="/reporteempresas" component={ReporteEmpresas} />
              <ProtectedRoute exact path="/reportenomina" component={ReporteNomina} />
              <ProtectedRoute exact path="/reciboscaja" component={RecibosCaja} />
              <ProtectedRoute exact path="/reportecartera" component={ReporteCartera} />
              <ProtectedRoute exact path="/reporterecibos" component={ReporteRecibos} />
              <ProtectedRoute exact path="/reportedetalladofe" component={ReporteDetallado} />
              <ProtectedRoute exact path="/reportedetalladonomina" component={ReporteDetalladoNomina} />
              <ProtectedRoute exact path="/barras" component={CodigoBarra} />
              <ProtectedRoute exact path="/codigobarra/crear" component={Formulariocodigobarras} />  
              <ProtectedRoute exact path="/empleados" component={Empleados} />
              <ProtectedRoute exact path="/empleados/crear" component={Formularioempleados} />
              <ProtectedRoute exact path="/gestionNomina" component={GestionNomina} />  
              <ProtectedRoute exact path="/gestionnominaemp" component={GestionesEmpleados} />  
              <ProtectedRoute exact path="/companyblock" component={EmpresasAdmin} />  
              <ProtectedRoute exact path="/saltoreporte" component={ReporteSalto} />  
              <ProtectedRoute exact path="/homologacion" component={HomologacionNomina} />  
              <ProtectedRoute exact path="/descuentos" component={Descuentos} />  
              <ProtectedRoute exact path="/reporteconsumo" component={ReporteConsumo} />  
              <ProtectedRoute exact path="/reportenominaemp" component={ReporteConsolidadoEmp} />  
              <ProtectedRoute exact path="/documentosoporte" component={DocumentoSoporte} />  

              {/* <ProtectedRoute exact path="/cierreturno" component={cierreturno} />      */} 
            </Switch>
          </BrowserRouter>
        </div>
      </div>
    );
  }
}

export default App;
